import { Configuration, MeApi } from "@eai-toolkit/client";
import axios from "axios";

export const axiosInstance = axios.create();

export function getBaseApiURL() {
  return process.env.REACT_APP_API_BASE_URL || window.location.origin;
}

export const apiConfiguration = new Configuration({
  basePath: getBaseApiURL(),
});

const meApi = new MeApi(apiConfiguration, "", axiosInstance);

export interface DataAccessLevel {
  hasWriteAccess: boolean;
  urn: string;
}

export async function checkDataAccessLevel(
  urn: string,
): Promise<DataAccessLevel> {
  try {
    await meApi.v1MeAllowedGet({
      action: "data:set",
      resource: urn,
    });

    return {
      // Non-error state means write access is allowed
      hasWriteAccess: true,
      urn: urn,
    };
  } catch (error) {
    console.error("Error checking data access level:", error);
    // Error state means write access is not allowed, must be read-only
    return {
      hasWriteAccess: false,
      urn: urn,
    };
  }
}
